/**
 * @generated SignedSource<<4602faf81629d75fd8b222760bee9a83>>
 * @relayHash ed4ecbfd9507c43dbef5a6f12220dd35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a7b8914129e8ce0e043424f0173c3622aeccdd75e7148d33ff3cf6eb4c115ca8

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type useCompleteFlowMutation$variables = {
  id: string;
};
export type useCompleteFlowMutation$data = {
  readonly devai_flowSessionComplete: {
    readonly id: string;
    readonly sessionARI: string;
    readonly status: DevAiFlowSessionsStatus | null | undefined;
  } | null | undefined;
};
export type useCompleteFlowMutation = {
  response: useCompleteFlowMutation$data;
  variables: useCompleteFlowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DevAiFlowSession",
    "kind": "LinkedField",
    "name": "devai_flowSessionComplete",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "sessionARI"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCompleteFlowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompleteFlowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "a7b8914129e8ce0e043424f0173c3622aeccdd75e7148d33ff3cf6eb4c115ca8",
    "metadata": {},
    "name": "useCompleteFlowMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "fd278c01fdd08d6ca6228a142f57d4e2";

export default node;
